var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideos = function SvgVideos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 451",
    viewBox: "0 0 46 46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "videos_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h46v46H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#videos_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.129 34.697a1.84 1.84 0 0 1-1.84-1.84V13.892a2.7 2.7 0 0 1 4.088-2.323l15.3 9.107a2.705 2.705 0 0 1 .086 4.594l-10.586 6.82a1.84 1.84 0 0 1-1.993-3.094l9.257-5.964-12.471-7.423v17.248a1.84 1.84 0 0 1-1.84 1.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 46a23 23 0 0 1 0-46 23.2 23.2 0 0 1 4.318.4 1.84 1.84 0 0 1-.686 3.616A19.6 19.6 0 0 0 23 3.68a19.315 19.315 0 1 0 11.227 3.594 1.84 1.84 0 0 1 2.141-2.994A23 23 0 0 1 23 46"
  }))));
};
export default SvgVideos;